
export default function About() {
  return (
    <section id="sobre" className="py-20 bg-gradient-to-b from-white to-red-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent mb-4">
            Sobre a The Joy School
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-red-600 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              A <strong>The Joy School Paulínia</strong> é uma escola infantil bilíngue que oferece um ambiente acolhedor e estimulante para crianças de 1 a 5 anos. Nossa missão é proporcionar uma educação de excelência, onde cada criança é valorizada e incentivada a desenvolver todo o seu potencial.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Com uma equipe pedagógica altamente qualificada e uma infraestrutura moderna e segura, criamos experiências de aprendizado significativas que preparam nossos alunos para um futuro brilhante em um mundo globalizado.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Acreditamos que a educação bilíngue desde a primeira infância abre portas para infinitas possibilidades, desenvolvendo não apenas habilidades linguísticas, mas também cognitivas, sociais e emocionais.
            </p>
            <a 
              href="https://wa.me/5519989250972?text=Olá,%20gostaria%20de%20mais%20informações%20sobre%20a%20The%20Joy%20School%20Paulínia."
              className="inline-block bg-gradient-to-r from-red-500 to-red-600 text-white px-8 py-4 rounded-full font-bold text-lg hover:from-red-600 hover:to-red-700 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              Fale com a The Joy
            </a>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-red-200 to-red-300 rounded-3xl transform -rotate-3"></div>
            <div className="relative bg-white rounded-3xl shadow-2xl p-8 transform rotate-1">
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-award-line text-white text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-slate-800 mb-2">Excelência Educacional</h3>
                    <p className="text-gray-600">Metodologia reconhecida e aprovada por pais e educadores.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-team-line text-white text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-slate-800 mb-2">Equipe Qualificada</h3>
                    <p className="text-gray-600">Professores especializados em educação infantil bilíngue.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-heart-line text-white text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-slate-800 mb-2">Ambiente Acolhedor</h3>
                    <p className="text-gray-600">Um segundo lar onde seu filho se sente seguro e feliz.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Seção de Vídeo de Apresentação */}
      <div className="mt-20 mb-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <span className="inline-block bg-red-100 text-red-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-play-circle-line mr-2"></i>
              Conheça Nossa Escola
            </span>
            <h3 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent mb-4">
              Vídeo de Apresentação
            </h3>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Descubra como a The Joy School Paulínia transforma a educação infantil bilíngue em uma experiência única e encantadora.
            </p>
          </div>
          
          <div className="relative max-w-2xl mx-auto">
            {/* Decoração de fundo */}
            <div className="absolute -inset-4 bg-gradient-to-br from-red-100 via-red-50 to-white rounded-3xl transform -rotate-1"></div>
            <div className="absolute -inset-4 bg-gradient-to-tr from-red-200/50 to-transparent rounded-3xl transform rotate-1"></div>
            
            {/* Container do vídeo */}
            <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden">
              <iframe 
                src="https://embed.screenapp.io/app/v/lqaL7SDY8e?embed=true" 
                width="100%" 
                height="960" 
                frameBorder="0" 
                allowFullScreen
                title="Vídeo de Apresentação - The Joy School Paulínia"
              ></iframe>
            </div>
            
            {/* Elementos decorativos */}
            <div className="absolute -top-6 -left-6 w-12 h-12 bg-red-500 rounded-full opacity-20"></div>
            <div className="absolute -bottom-4 -right-4 w-20 h-20 bg-red-400 rounded-full opacity-15"></div>
          </div>
        </div>
      </div>

      {/* Seção de Metodologia - Largura Total */}
      <div className="mt-16">
        <div className="max-w-7xl mx-auto px-4 mb-8">
          <h4 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent mb-4 text-center">
            Nossa Metodologia – Educação Bilíngue
          </h4>
          <p className="text-lg text-gray-700 leading-relaxed text-center max-w-4xl mx-auto">
            Desenvolvemos uma metodologia única de ensino bilíngue que preocupa-se em promover a experimentação, a descoberta, o compartilhamento de ideias e informações, tanto em atividades realizadas individualmente como em grupos. Nossas propostas são lúdicas, geram curiosidade e incentivam a criatividade; sempre estimulando a comunicação na segunda língua.
          </p>
        </div>
        
        {/* Banner em largura total */}
        <div className="w-full overflow-hidden">
          <img 
            src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/216eb8c6f9e4e6237ae6df3679dec327.png"
            alt="Metodologia de Educação Bilíngue - The Joy School"
            className="w-full h-auto"
          />
        </div>
      </div>
    </section>
  );
}
